import { EthDateTime } from "ethiopian-calendar-date-converter";

import { ethDateFormatter } from "./ethDateFormatter";

export function ethDate(date) {
    const ethiopianDate = EthDateTime.fromEuropeanDate(new Date(date));
    return ethDateFormatter(ethiopianDate);
}